// import { Box, Typography, Button, Hidden } from "@mui/material";
// import Header from "./Header.js";
// import AllFilters from "./Filter/Filters";
// import UserTable from "./Users/UserTable.js";
// import AddUserForm from "./UserForm.js";
// import { useCallback, useEffect, useState } from "react";
// import axiosInstance from "../../../services/axiosInterceptors.js";
// import apiEndPointsConfig from "../../../services/apiEndPoints.js";
// import ParentWrapper from "../../../components/ParentWrapper.jsx";
// import { useDebounce } from "react-use";
// import AnimationLoader from "../../../components/AnimatedLoader.js";

// function UserManagement() {
//   const [showForm, setShowForm] = useState(false);
//   const [editingUser, setEditingUser] = useState(null);
//   const [users, setUsers] = useState([]);
//   const [role, setRole] = useState("");
//   const [status, setStatus] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");
//   const [cache, setCache] = useState({});
//   const [loading, setLoading] = useState(true);

//   useDebounce(() => setDebouncedSearch(searchTerm), 400, [searchTerm]);

//   const buildKey = (r, s, st) => `${r}::${s}::${st}`;

//   const fetchUsers = useCallback(
//     async ({ r = "", s = "", st = "" } = {}) => {

//       const key = buildKey(r, s, st);
//       if (cache[key]) {
//         setUsers(cache[key]);
//         console.log("Data from cache", users);
//         setLoading(false);
//         return;
//       }
//       try {

//         const data = { role: r=="All"?"":r, status: s=="All"?"":s, searchTerm: st === "All"?"":st };
//         const token = localStorage.getItem("token");

//         const res = await axiosInstance.post(
//           apiEndPointsConfig.getUsers,
//           data,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         const list = res?.data?.data ?? [];
//         setUsers(list);
//         console.log("Data from api", users);
//         setCache((prev) => ({ ...prev, [key]: list }));
//       } catch (e) {
//         console.error(e);
//         setUsers([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [cache]
//   );

//   useEffect(() => {
//     fetchUsers({ r: role, s: status, st: debouncedSearch });
//   }, [role, status, debouncedSearch, fetchUsers]);

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//     const refreshUsers = useCallback(async () => {
//     setCache({});
//     await fetchUsers({ r: role, s: status, st: debouncedSearch });
//   }, [fetchUsers, role, status, debouncedSearch]);

//   const handleAdd = (data) => {
//     setShowForm(true);
//   };

//   const handleSaveAndRefresh = async () => {
//     await refreshUsers();
//     setShowForm(false);
//     setEditingUser(null);
//   };

//   const handleEdit = (values) => {
//     console.log("edit user", values);
//     setEditingUser(values);
//     setShowForm(true);
//   };

//   const handleDelete = async (agentId) => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axiosInstance.delete(
//         apiEndPointsConfig.deleteUser,
//         {
//           data: { employeeId: agentId },
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       console.log("Delete response", response);
//       if (response.status == 200)
//         setUsers((prev) => prev.filter((u) => u.agentId !== agentId));
//     } catch (e) {
//       console.error("Delete failed:", e);
//     }
//   };

//   if (loading) return <AnimationLoader />;

//   return (
//     <>
//       {showForm && (
//         <Box
//           sx={{
//             display: { xs: "none", md: "block" },
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "#fafbfcc3",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(8px)",
//             zIndex: 1299,
//           }}
//         />
//       )}
//       <ParentWrapper>
//         <Header
//           onAdd={() => {
//             setEditingUser(null);
//             setShowForm(true);
//           }}
//         />

//         <AllFilters
//           role={role}
//           setRole={setRole}
//           status={status}
//           setStatus={setStatus}
//           searchTerm={searchTerm}
//           setSearchTerm={setSearchTerm}
//         />

//         <UserTable
//           users={users}
//           onEdit={handleEdit}
//           onRowClick={handleEdit}
//           setShowForm={setShowForm}
//           onDelete={handleDelete}
//         />
//         <AddUserForm
//           users={users}
//           open={showForm}
//           onClose={() => {
//             setShowForm(false);
//             setEditingUser(null);
//           }}
//           onSave={handleSaveAndRefresh}
//           user={editingUser}
//         />
//       </ParentWrapper>
//     </>
//   );
// }
// export default UserManagement;









// import { Box } from "@mui/material";
// import Header from "./Header.js";
// import AllFilters from "./Filter/Filters";
// import UserTable from "./Users/UserTable.js";
// import AddUserForm from "./UserForm.js";
// import { useCallback, useEffect, useState } from "react";
// import axiosInstance from "../../../services/axiosInterceptors.js";
// import apiEndPointsConfig from "../../../services/apiEndPoints.js";
// import ParentWrapper from "../../../components/ParentWrapper.jsx";
// import { useDebounce } from "react-use";
// import AnimationLoader from "../../../components/AnimatedLoader.js";

// function UserManagement() {
//   const [showForm, setShowForm] = useState(false);
//   const [editingUser, setEditingUser] = useState(null);
//   const [users, setUsers] = useState([]);
//   const [selectedRole, setSelectedRole] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [searchInput, setSearchInput] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");
//   const [cache, setCache] = useState({});
//   const [loading, setLoading] = useState(true);

//   // use debounce for optimize search,prevents rate litimitng
//   useDebounce(() => setDebouncedSearch(searchInput), 400, [searchInput]);

//   // Create a unique key for caching based on filters
//   const buildCacheKey = (role, status, search) =>
//     `${role}::${status}::${search}`;

//   // Fetch users (with local caching) based on current filters
//   const fetchUsers = useCallback(
//     async ({ role = "", status = "", search = "" } = {}) => {
//       const key = buildCacheKey(role, status, search);

//       if (cache[key]) {
//         setUsers(cache[key]);
//         setLoading(false);
//         return;
//       }

//       try {
//         const payload = {
//           role: role === "All" ? "" : role,
//           status: status === "All" ? "" : status,
//           searchTerm: search === "All" ? "" : search,
//         };
//         const token = localStorage.getItem("token");

//         const response = await axiosInstance.post(
//           apiEndPointsConfig.getUsers,
//           payload,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         console.log("Users response", response);

//         const userList = response?.data?.data ?? [];
//         const filteredUsers = userList?.filter(
//           (user) => user.role !== "SuperAdmin"
//         );

//         setUsers(filteredUsers);
//         setCache((prev) => ({ ...prev, [key]: filteredUsers }));
//       } catch (error) {
//         console.error(error);
//         setUsers([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [cache]
//   );

//   // Refetch users when filters change
//   useEffect(() => {
//     fetchUsers({
//       role: selectedRole,
//       status: selectedStatus,
//       search: debouncedSearch,
//     });
//   }, [selectedRole, selectedStatus, debouncedSearch, fetchUsers]);

//   // Initial users fetch
//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   // Clear cache and reload users with current filters
//   const refreshUsers = useCallback(async () => {
//     setCache({});
//     await fetchUsers({
//       role: selectedRole,
//       status: selectedStatus,
//       search: debouncedSearch,
//     });
//   }, [fetchUsers, selectedRole, selectedStatus, debouncedSearch]);

//   // Open empty form to add a new user
//   const handleAddUser = () => {
//     setEditingUser(null);
//     setShowForm(true);
//   };

//   // Save changes and refresh the list
//   const handleSaveAndRefresh = async () => {
//     await refreshUsers();
//     setShowForm(false);
//     setEditingUser(null);
//   };

//   // Open form pre-filled with selected user data
//   const handleEditUser = (userData) => {
//     setEditingUser(userData);
//     setShowForm(true);
//   };

//   // Delete user and remove from local list
//   const handleDeleteUser = async (agentId) => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axiosInstance.delete(
//         apiEndPointsConfig.deleteUser,
//         {
//           data: { employeeId: agentId },
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       console.log("delete response", response);

//       if (response.status === 200) {
//         setUsers((prev) => prev.filter((user) => user.agentId !== agentId));
//       }
//     } catch (error) {
//       console.error("Delete failed:", error);
//     }
//   };

//   // Show loader while initial data is fetched
//   if (loading) return <AnimationLoader />;

//   return (
//     <>
//       {showForm && (
//         <Box
//           sx={{
//             display: { xs: "none", md: "block" },
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "#fafbfcc3",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(8px)",
//             zIndex: 1299,
//           }}
//         />
//       )}

//       <ParentWrapper>
//         <Header onAdd={handleAddUser} />

//         <AllFilters
//           role={selectedRole}
//           setRole={setSelectedRole}
//           status={selectedStatus}
//           setStatus={setSelectedStatus}
//           searchTerm={searchInput}
//           setSearchTerm={setSearchInput}
//         />

//         <UserTable
//           users={users}
//           onEdit={handleEditUser}
//           onDelete={handleDeleteUser}
//           loading={loading}
//         />

//         <AddUserForm
//           users={users}
//           open={showForm}
//           onClose={() => {
//             setShowForm(false);
//             setEditingUser(null);
//           }}
//           onSave={handleSaveAndRefresh}
//           user={editingUser}
//         />
//       </ParentWrapper>
//     </>
//   );
// }

// export default UserManagement;









import { Box } from "@mui/material";
import Header from "./Header.js";
import AllFilters from "./Filter/Filters";
import UserTable from "./Users/UserTable.js";
import AddUserForm from "./UserForm.js";
import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../services/axiosInterceptors.js";
import apiEndPointsConfig from "../../../services/apiEndPoints.js";
import ParentWrapper from "../../../components/ParentWrapper.jsx";
import { useDebounce } from "react-use";
import AnimationLoader from "../../../components/AnimatedLoader.js";
import Loader from "../../../components/AnimatedLoader.js";

const LS_KEY = "userFilters";             

/* ---------- local storage functions ---------- */
const getSaved = () => {
  try {
    const s = JSON.parse(localStorage.getItem(LS_KEY) || "{}");
    return { role: s.role || "", status: s.status || "", search: s.search || "" };
  } catch {
    return { role: "", status: "", search: "" };
  }
};
const saveFilters = (f) => localStorage.setItem(LS_KEY, JSON.stringify(f));

function UserManagement() {
  /* ---------- state ---------- */
  const saved = getSaved();
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [cache, setCache] = useState({});
  const [loading, setLoading] = useState(true);

  const [role, setRole] = useState(saved.role);
  const [status, setStatus] = useState(saved.status);
  const [search, setSearch] = useState(saved.search);
  const [debouncedSearch, setDebouncedSearch] = useState(saved.search);

  useDebounce(() => setDebouncedSearch(search), 400, [search]);

  /* ---------- save on every change ---------- */
  useEffect(() => saveFilters({ role, status, search }), [role, status, search]);

  /* ---------- fetch users (cached) ---------- */
  const cacheKey = `${role}::${status}::${debouncedSearch}`;

  const loadUsers = useCallback(async () => {
    if (cache[cacheKey]) {                // hit cache
      setUsers(cache[cacheKey]);
      return setLoading(false);
    }

    setLoading(true);
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.getUsers,
        {
          role: role === "All" ? "" : role,
          status: status === "All" ? "" : status,
          searchTerm: debouncedSearch === "All" ? "" : debouncedSearch,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );

      const list = (res.data?.data || []).filter((u) => u.role !== "SuperAdmin");
      setUsers(list);
      setCache((c) => ({ ...c, [cacheKey]: list }));
    } catch (e) {
      console.error(e);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  }, [role, status, debouncedSearch, cache, cacheKey]);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  /* ---------- handlers ---------- */
  const refresh = () => 
    { setCache({}); loadUsers();
 };

  const addUser = () => { setEditingUser(null); setShowForm(true); };
  const editUser = (u) => { setEditingUser(u); setShowForm(true); };

  const deleteUser = async (id) => {
    try {
      await axiosInstance.delete(apiEndPointsConfig?.deleteUser, {
        data: { employeeId: id },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setUsers((list) => list.filter((u) => u.agentId !== id));
    } catch (e) {
      console.error("Delete failed", e);
    }
  };

  const saveClose = () => { refresh(); setShowForm(false); setEditingUser(null); };

  /* ---------- render ---------- */
  if (loading) return <Loader />;

    
  return (
  <>
    {showForm && (
      <ParentWrapper>
        <Box
          sx={{
            display: { xs: 'none', md: 'block' },
            position: 'fixed',
            inset: 0,
            backgroundColor: '#fafbfcc3',
            backdropFilter: 'blur(5px)',
            zIndex: 1299,
          }}
        />
      </ParentWrapper>
    )}

    
    <ParentWrapper>
      <Header onAdd={addUser} />

    <AllFilters
      role={role}
      setRole={setRole}
      status={status}
      setStatus={setStatus}
      searchTerm={search}
      setSearchTerm={setSearch}
    />

    <UserTable
      users={users}
      onEdit={editUser}
      onDelete={deleteUser}
      refresh={refresh}
    />

    <AddUserForm
      open={showForm}
      onClose={() => {
        setShowForm(false);
        setEditingUser(null);
      }}
      onSave={saveClose}
      user={editingUser}
    />
    </ParentWrapper>
  </>
);
}

export default UserManagement;




